import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { showToast } from "@/redux/features/toast";
import { listToast } from "@/utils";
import ShowFile from "./ShowFile";
import { Button, Image } from "@/uiCore";
export const UploadFile = (props) => {
  const { file, setFile = () => {}, label, isView, target, width } = props;
  const dispatch = useDispatch();
  const fileType = file?.type;
  const originFile = file;
  const convertSizeToMB = (fileSize) => {
    return (fileSize / (1024 * 1024)).toFixed(2);
  };
  useEffect(() => {
    return () => {
      file && URL.revokeObjectURL(file.preview);
    };
  }, [file]);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const size = convertSizeToMB(file.size);
    if (size > 19) {
      dispatch(
        showToast({
          ...listToast[2],
          detail: "Vui lòng chọn file kích thước nhỏ hơn 20MB!",
        })
      );
      return;
    }
    if (file.type) file.preview = URL.createObjectURL(file);
    setFile(file);
  };

  const clearImg = () => {
    setFile(null);
  };
  const Show = ({ file, fileType }) => {
    if (
      file &&
      (fileType ? !fileType?.includes("image") : true) &&
      (typeof file === "string" ? !file.endsWith("webp") : true)
    ) {
      return (
        <ShowFile
          originFile={originFile}
          width={width}
          target={target}
          link={file.url || file.name || file}
          className="font-semibold"
        >
          {file.name || file}
        </ShowFile>
      );
    } else if (
      file &&
      (typeof file === "string" ? file.endsWith("webp") : true)
    ) {
      return (
        <Image
          src={
            typeof file === "string"
              ? file || "/assets/img/imgIcon.png"
              : file?.preview || file?.name || "/assets/img/imgIcon.png"
          }
          alt="Image"
          width="130"
          height="150"
          preview
        />
      );
    }
  };

  return (
    <div className="mb-3 px-2">
      <label className="font-medium">{label}</label>
      <div className="card mt-2">
        {!isView && (
          <div className="flex justify-content-end align-items-center mb-3">
            <div className="flex align-items-center gap-2">
              <Button
                icon="pi pi-times"
                disabled={!file}
                onClick={clearImg}
                severity="danger"
                label="Bỏ chọn"
                type="button"
              />
              <label
                className="p-button p-fileupload-choose p-component"
                style={{ minHeight: "40px" }}
              >
                <i className="pi pi-plus mr-2"></i>
                <span className="p-button-text p-clickable">Chọn file</span>
                <input
                  type="file"
                  onChange={handleFile}
                  className="p-inputtext p-component"
                />
              </label>
            </div>
          </div>
        )}
        <div className="card bg-color flex">
          <Show file={file} fileType={fileType} />
        </div>
      </div>
    </div>
  );
};
